<template>
  <div class="app-container" id="navError">

    <nav class="head">
      <h2>Page Not Found</h2>
      <router-link to="/home" tag="button">Home</router-link>
    </nav>

    <div class="content">
      <p>The page you're looking for can not be found.</p>
      <p>Route <b class="route-error">{{$route.path}}</b> does not compute.</p>
    </div>
    
  </div>
</template>

<script>
  module.exports =  {
    name: 'app',
    data () {
      return {}
    },

    mounted() {
      console.log(`NavError.mounted()`);
    }
  }
</script>

<style scoped>
  .content {
    padding: 20px;
  }
  .route-error {
    color: orangered;
  }
</style>